module.exports = __webpack_public_path__ + "img/06_apple orage plate.628e0e4b.png";